function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".st0{stroke:#3c00dc}.st0,.st1{fill:none}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_213",
  transform: "rotate(90 1304.112 381.193)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_37",
  className: "st0",
  d: "M996.4 1669.8v-39.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_38",
  className: "st0",
  d: "M970 1645.9l21.1-18"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_39",
  className: "st0",
  d: "M988.6 1678.6h-49.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_40",
  className: "st0",
  d: "M958.8 1645.9l-21.1-18"
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_77",
  transform: "translate(955.919 1642.304)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 8,
  cy: 8,
  r: 7.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_78",
  transform: "translate(922.919 1615.304)"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st1",
  cx: 8.5,
  cy: 8,
  rx: 8,
  ry: 8.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st0",
  cx: 8.5,
  cy: 8,
  rx: 7.5,
  ry: 8
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_79",
  transform: "translate(922.919 1669.304)"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st1",
  cx: 8.5,
  cy: 8,
  rx: 8,
  ry: 8.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st0",
  cx: 8.5,
  cy: 8,
  rx: 7.5,
  ry: 8
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_81",
  transform: "translate(987.919 1669.304)"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st1",
  cx: 8.5,
  cy: 8,
  rx: 8,
  ry: 8.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st0",
  cx: 8.5,
  cy: 8,
  rx: 7.5,
  ry: 8
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_80",
  transform: "translate(987.919 1614.304)"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st1",
  cx: 8.5,
  cy: 8,
  rx: 8,
  ry: 8.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90 8.5 8)",
  className: "st0",
  cx: 8.5,
  cy: 8,
  rx: 7.5,
  ry: 8
})));

function SvgGraphinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 71 82",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgGraphinline;